//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[1,"BallRadiusExpression",0,"Expression",0],[0,"BendMoment",1,0],[1,"BendingArmExpression",0,"Expression",0],[0,"Effect",1,0],[1,"ForcePreloadExpression",0,"Expression",0],[1,"FrictionArmExpression",0,"Expression",0],[1,"InitialOverlapExpression",0,"Expression",0],[1,"MaxStictionDeformationExpression",0,"Expression",0],[1,"MuDynamicExpression",0,"Expression",0],[1,"MuStaticExpression",0,"Expression",0],[0,"OverlapDelta",1,0],[1,"PinRadiusExpression",0,"Expression",0],[0,"Preload",1,0],[1,"ReactionArmExpression",0,"Expression",0],[0,"ReactionForce",1,0],[0,"StaticEqu",1,0],[1,"StictionTransitionVelocityExpression",0,"Expression",0],[1,"TorquePreloadExpression",0,"Expression",0],[0,"TorsionalMoment",1,0],[0,"YokeType",1,0]],[],[]];
SPLM.Motion.JointFrictionAdams = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.JointFrictionAdams";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.JointFrictionAdams.FrictionEffect = Object.freeze({
    "All" : "All", "Stiction" : "Stiction", "Sliding" : "Sliding"});

SPLM.Motion.JointFrictionAdams.FrictionYokeType = Object.freeze({
    "I" : "I", "J" : "J"});

SPLM.Motion.JointFrictionAdams.FrictionOverlapDelta = Object.freeze({
    "Constant" : "Constant", "Increase" : "Increase", "Decrease" : "Decrease"});

export default SPLM;